// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__sQBYA","ant-page-header-heading-title":"styles_ant-page-header-heading-title__1dAra","table":"styles_table__FuV5d"};